import React from 'react';
import Modal, { ModalBody, ModalHeader } from '../../../components/modal/Modal';
import ModalImage from '../../../components/modal/ModalImage';

const FeatureDetailsModal = ({ onClose, featureModalData }) => {
  const {
    disclaimer,
    imageUrl: image,
    longDescription: description,
    shortDescription: title,
  } = featureModalData.featureModalInfo;

  return (
    <Modal isOpen={true} onRequestClose={onClose}>
      <ModalHeader
        text={title}
        onClose={onClose}
        analyticsKey={`compare trims:${title}`}
      />
      <ModalBody>
        <div className="feature-details__container">
          <div className="feature-details">
            <div
              dangerouslySetInnerHTML={{ __html: description }}
              className="feature-details__description"
            />
            <div
              dangerouslySetInnerHTML={{ __html: disclaimer }}
              className="feature-details__disclaimer"
            />
          </div>
          <ModalImage
            url={image ? image : null}
            alt={title}
            showImageDisclosure
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default FeatureDetailsModal;
